import {
    ACCOUNT_MANAGERS_SET_LOADING,
    ACCOUNT_MANAGERS_LIST,
    ACCOUNT_MANAGERS_USER_LIST,
    ACCOUNT_MANAGERS_REFERENCES,
    ACCOUNT_MANAGERS_BIL, ACCOUNT_MANAGERS_INFORMATORS_LIST, ACCOUNT_MANAGERS_DROPDOWN_LIST,
} from '../const'

const initialState = {
    list: [],
    loading: true,
    dropdown_list: [],
    dropdown_loading: true,
    userList: [],
    teamLeadList: [],
    billingList: [],
    informators: {}
};

const handlers = {
    [ACCOUNT_MANAGERS_SET_LOADING]: (state, {payload}) => ({...state, loading: payload}),
    [ACCOUNT_MANAGERS_LIST]: (state, {payload: {list}}) => ({
        ...state,
        list: list,
        loading: false,
    }),
    [ACCOUNT_MANAGERS_DROPDOWN_LIST]: (state, {payload: {list}}) => ({
        ...state,
        dropdown_list: list,
        dropdown_loading: false,
    }),
    [ACCOUNT_MANAGERS_USER_LIST]: (state, {payload: {userList}}) => ({
        ...state,
        userList: userList,
    }),
    [ACCOUNT_MANAGERS_REFERENCES]: (state, {payload: {userList, teamLeadList}}) => ({
        ...state,
        userList: userList,
        teamLeadList: teamLeadList,
    }),
    [ACCOUNT_MANAGERS_BIL]: (state, {payload: {list}}) => ({
        ...state,
        billingList: list,
    }),
    [ACCOUNT_MANAGERS_INFORMATORS_LIST]: (state, {payload: {informators}}) => ({
       ...state,
       informators
    }),
    DEFAULT: state => state
};

export default (state = initialState, action) => {
    const handle = handlers[action.type] || handlers.DEFAULT;
    return handle(state, action);
}